<template>
  <div class="wrapper">

    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand bg-white navbar-light border-bottom">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#"><i class="fa fa-bars"></i></a>
        </li>
      </ul>
      <b-collapse is-nav id="nav_collapse">
        <template v-if="!user">
          <b-dropdown id="ddown-form" text="Login" ref="ddown" class="ml-auto">
            <b-dropdown-form style="min-width:300px">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <fa-icon icon="user"></fa-icon>
                  </b-input-group-prepend>
                  <b-form-input v-model="inputuser"
                    placeholder="usuario"></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <fa-icon icon="lock"></fa-icon>
                  </b-input-group-prepend>
                  <b-form-input type="password"
                    placeholder="contraseña" v-model="password"
                    @keyup.enter.native="doLogin"></b-form-input>
                </b-input-group>
              <b-button variant="primary" size="sm" @click="doLogin">Entrar</b-button>
            </b-dropdown-form>
          </b-dropdown>
        </template>
        <template v-else>
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown right>
              <template slot="button-content">
                <em>{{user.name}}</em>
              </template>
              <b-dropdown-item @click="logout()">Salir</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </template>
      </b-collapse>
    </nav>
    <!-- /.navbar -->

    <!-- Main Sidebar Container -->
    <aside class="main-sidebar sidebar-dark-primary elevation-4">
      <!-- Brand Logo -->
      <a href="/" class="brand-link">
        <img src="./assets/img/LogoInspecta2.png" alt="S" class="brand-image img-circle elevation-3"
            style="opacity: .8">
        <span class="brand-text font-weight-light">INSPECTA INMAC</span>
      </a>

      <!-- Sidebar -->
      <div class="sidebar">
        <!-- Sidebar user panel (optional) -->
        <template v-if="user" >
          <div class="user-panel mt-3 pb-3 mb-3 d-flex">
              <div class="image">
                <img src="./assets/img/avatar5.png" class="img-circle elevation-2" alt="User Image">
              </div>
              <div class="info">
                <a href="#" class="d-block">{{user.name}}</a>
              </div>
          </div>
        </template>
        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            <li class="nav-item">
              <a href="/" class="nav-link">
                <i class="nav-icon fa fa-home"></i>
                <p>
                  Inicio
                </p>
              </a>
            </li>
            <li class="nav-item has-treeview">
              <a href="#" class="nav-link">
                <i class="nav-icon fas fa-mobile"></i>
                <p>
                  Datos Offline
                  <i class="right fa fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item" v-bind:key="'li_local_'+key" v-for="(entity, key) in entities">
                  <router-link :to="{ name: 'list', params: { typex: 'local', json: key }}"
                    class="nav-link " active-class="active" >
                    <i class="fas fa-clipboard-list nav-icon"></i><p>{{entity}}</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item has-treeview">
              <a href="#" class="nav-link">
                <i class="nav-icon fas fa-database"></i>
                <p>
                  Bases de Datos
                  <i class="right fa fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item" v-bind:key="'li_server_'+key" v-for="(entity, key) in entities">
                  <router-link :to="{ name: 'list', params: { typex: 'server', json: key }}"
                    class="nav-link " active-class="active" >
                    <i class="fas fa-wifi nav-icon"></i><p>{{entity}}</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item has-treeview">
              <a href="#" class="nav-link">
                <i class="nav-icon fas fa-chart-area"></i>
                <p>
                  Reportes
                  <i class="right fa fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item">
                  <router-link :to="{ name: 'map', params: { typex:'server', json: 'inspection' }}"
                    class="nav-link " active-class="active" >
                    <i class="fas fa-map-marked nav-icon"></i><p>Mapa</p>
                  </router-link>
                </li>

                <!-- limit -->
                <li class="nav-item">
                  <router-link :to="{ name: 'dashboard', params: { typex:'server', json: 'inspection' }}"
                    class="nav-link " active-class="active" >
                    <i class="fas fa-tachometer-alt nav-icon"></i><p>Dashboard</p>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{ name: 'dashboardLote', params: { typex:'server', json: 'inspection' }}"
                    class="nav-link " active-class="active" >
                    <i class="fas fa-tachometer-alt nav-icon"></i><p>Dashboard Lote</p>
                  </router-link>
                </li>
                <!-- limit end -->

              </ul>
            </li>
            <li class="nav-item has-treeview">
              <a href="#" class="nav-link">
                <i class="nav-icon fas fa-walking"></i>
                <p>
                  Patrullaje
                  <i class="right fa fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item">
                  <router-link :to="{ name: 'list', params: { typex:'server', json: 'catodico_patrullaje' }}"
                    class="nav-link " active-class="active" >
                    <i class="fas fa-book-open nav-icon"></i><p>Insp. Catódica</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'config' }"
                class="nav-link " active-class="active" >
                <i class="fas fa-cog nav-icon"></i><p>Configuración</p>
              </router-link>
            </li>
            <li class="nav-item">
              <a href="https://inspecta2.inmac.work/manual.pdf"
                class="nav-link " active-class="active" >
                <i class="fas fa-book-open nav-icon"></i><p>Manual Inspecta</p>
              </a>
              <!-- <router-link :to="{ name: 'manual' }"
                class="nav-link " active-class="active" >
                <i class="fas fa-book-open nav-icon"></i><p>Manual Inspecta</p>
              </router-link> -->
            </li>
          </ul>
          <div class="foot" style="text-align: center;">
            Versión - {{settings.version}} <br> Developed by I + D + I
          </div>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
    </aside>

    <div class="content-wrapper">
      <div class="content">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { settings } from './configuration/settings'
// eslint-disable-next-line
window.lte = require('imports-loader?jQuery=jquery!./assets/adminlte/adminlte.js')

export default {
  name: 'app',
  data () {
    return {
      activeSidebar: false,
      inputuser: '',
      password: '',
      settings: settings
    }
  },
  created: function () {
    this.init()
  },
  computed: {
    ...mapState([
      'user',
      'entities'
    ])
  },
  methods: {
    toggleSidebar () {
      this.activeSidebar = !this.activeSidebar
    },
    doLogin () {
      var payload = { user: this.inputuser, pass: this.password }
      this.password = ''
      return this.login(payload)
    },
    ...mapActions([
      'login',
      'logout',
      'init',
      'check_login'
    ])
  }
}
</script>
<style>
.foot { position: absolute; bottom: 0; padding-left: 50px; height: 40px; width: inherit; color: white; opacity: 0.3; font-size: 13px;}
</style>
